import store from '@/store/store'

export function memberHasNoEmailAddress() {
  const user = store.getters['Member/user']
  return user && user.email.startsWith('no-email+')
}
